/**
 * query-retry.ts — Thử lại cho truy vấn quan trọng (danh sách hội thoại) khi lỗi TẠM THỜI: mất mạng, 5xx, 408, và 429
 * (vượt giới hạn tần suất — chờ đúng `Retry-After` máy chủ báo). Lỗi do yêu cầu (400, 403, 404…) thì không thử lại.
 */

interface HttpLikeError {
  response?: { status?: number; headers?: Record<string, unknown> }
}

function statusOf(err: unknown): number | undefined {
  return (err as HttpLikeError | null)?.response?.status
}

/** Có nên thử lại không — tối đa `max` lần, chỉ với lỗi tạm thời. */
export function shouldRetryQuery(failureCount: number, err: unknown, max = 3): boolean {
  if (failureCount >= max) return false
  const s = statusOf(err)
  if (s === undefined) return true // mất mạng / hết thời gian chờ
  return s >= 500 || s === 408 || s === 429
}

/** Chờ bao lâu trước lần thử lại thứ `attempt` (0, 1, 2…): 429 theo Retry-After (2–30 giây), còn lại giãn dần 1→8 giây. */
export function retryDelayMs(attempt: number, err: unknown): number {
  if (statusOf(err) === 429) {
    const raw = Number((err as HttpLikeError).response?.headers?.['retry-after'])
    const sec = Number.isFinite(raw) && raw > 0 ? raw : 10
    return Math.min(30, Math.max(2, sec)) * 1000
  }
  return Math.min(1000 * 2 ** attempt, 8000)
}

/** Đã hết lượt thử lại mà vẫn lỗi → tự thử tiếp theo nhịp này (thay vì kẹt màn lỗi tới khi tải lại trang). */
export const ERROR_REFETCH_MS = 20_000
